<template>
    <div class="growthBookEvaluationtemplateindex">       
        <el-table stripe :data="dataList" border fit highlight-current-row   style="width: 100%" :height="`${(maxH)}px`">            					              
            <el-table-column align="center" label="名称" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span class="link" @click="growthfootprintevaluationtemplateeidt(scope.row.id)">{{scope.row.title}}</span>
                </template>
            </el-table-column>
            <el-table-column align="center" label="适用年段"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.levelName}}  {{scope.row.term==1?'上学期':'下学期'}}</span>
                </template>
            </el-table-column>  
            <el-table-column align="center" label="说明"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.remark}}</span>
                </template>
            </el-table-column>  
             <el-table-column align="center" label="更新时间"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <span>{{scope.row.updateDate?(scope.row.updateDate.split('.')[0]):(scope.row.createDate.split('.')[0])}}</span>
                </template>
            </el-table-column>          
            <el-table-column align="center"  label="状态" width="100"  show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-tag size="mini" type="info" v-if="scope.row.enable==0">未启用</el-tag>
                    <el-tag size="mini" type="success" v-if="scope.row.enable==1">已启用</el-tag>
                </template>
            </el-table-column>
            <el-table-column align="center" label="操作" width="200">
                <template slot-scope="scope">
                    <el-button size="small" type="text"  @click.native="dialogVisiblefun(scope.row)" v-if="scope.row.enable==0">编辑 </el-button>
                    <el-button size="small" type="text"  @click.native="enableAssessTemplates(1,scope.row)" v-if="scope.row.enable==0">启用</el-button>
                    <el-button size="small" type="text"  @click.native="enableAssessTemplates(0,scope.row)" v-if="scope.row.enable==1">关闭</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-dialog title="编辑发展评估" :close-on-press-escape='false' :close-on-click-modal='false' :visible.sync="dialogVisible" width="700px" :lock-scroll="false" :modal-append-to-body='false'>
			  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
                <el-form-item label="发展评估名称" prop="title" >
                    <el-input v-model.trim="ruleForm.title" placeholder="请输入发展评估名称" size="medium" :maxlength="20"></el-input>
                </el-form-item>   
                <el-form-item label="适用年段" >
                    <el-input v-model.trim="ruleForm.name" disabled size="medium" :maxlength="20"></el-input>
                </el-form-item> 
                <el-form-item label="发展评估说明" prop="remark" >
                    <el-input v-model.trim="ruleForm.remark" placeholder="请输入发展评估说明" size="medium" :maxlength="20"></el-input>
                </el-form-item>      
                </el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="editAssessTemplate('ruleForm')">确 定</el-button>
			</span>
		</el-dialog>

    </div>
</template>
<script>
    import windowResize from "@/mixins/windowResize";
    import {getAssessTemplateBySchoolId,enableAssessTemplate,insertAssessTemplate,editAssessTemplate} from '@/api/growthfootprint';
    export default {
        data() {
            return {
                dataList: [],
                searchName:'',
                ruleForm: {
                    remark: "",
                    title:"",
                    id:"",
                    name:""
                },
            dialogVisible: false,
            rules: {
                remark: [
                { required: true, message: "请输入发展评估说明", trigger: "blur" }
                ],
                title: [
                { required: true, message: "请输入发展评估名称", trigger: "change" }
                ]
            },
            }
        },
        mixins: [windowResize],       
        created() {
            this.getAssessTemplateBySchoolIds()
        },
        methods: {   
            dialogVisiblefun(obj){
                this.ruleForm.remark=obj.remark;
                this.ruleForm.id=obj.id;
                this.ruleForm.title=obj.title;
                this.ruleForm.name=obj.levelName+(obj.term==1?'上学期':'下学期');
                this.dialogVisible=true;
            },   
            editAssessTemplate(formName) {
                this.$refs[formName].validate(valid => {
                    if (valid) {
                    editAssessTemplate(this.ruleForm)
                        .then(res => {
                            if (res.data.code === 200) {
                            this.$message({
                                type: "success",
                                message: "编辑成功!"
                            });
                            }
                            this.dialogVisible = false;
                            this.getAssessTemplateBySchoolIds();
                        })
                        .catch(err => {});
                    }
                });
            },  
            //获取列表
            getAssessTemplateBySchoolIds() {
                getAssessTemplateBySchoolId(this.searchName)
                    .then(res => res.data)
                    .then(data => {
                        this.dataList = data.data;
                        if(this.dataList.length==0){
                            this.insertAssessTemplate();
                        }
                    })
            },       
            insertAssessTemplate(){
                let domainList=[{domainName:"健康"},{domainName:"语言"},{domainName:"社会"},{domainName:"科学"},{domainName:"艺术"}];                
                for(let i=1;i<4;i++){
                    let oneobj={
                    domainList:domainList,
                    level:i,
                    term:1,
                    levelName:i==1?"小班":(i==2?"中班":"大班"),
                    title:(i==1?"小班":(i==2?"中班":"大班"))+"上学期发展评估模板",
                    remark:"基于《3~6岁儿童学习与发展指南》的评价项"
                    };
                    let twoobj={
                    domainList:domainList,
                    level:i,
                    term:2,
                    levelName:i==1?"小班":(i==2?"中班":"大班"),
                    title:(i==1?"小班":(i==2?"中班":"大班"))+"下学期发展评估模板",
                    remark:"基于《3~6岁儿童学习与发展指南》的评价项"
                    };
                   insertAssessTemplate(oneobj)
                    .then(res => {this.getAssessTemplateBySchoolIds();})
                    .catch(err => {});
                     insertAssessTemplate(twoobj)
                    .then(res => {this.getAssessTemplateBySchoolIds();})
                    .catch(err => {});

                }

            },  
            enableAssessTemplates(num,obj){
                let name=num==0?'关闭':'启用'
                this.$confirm('是否'+name, name, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    enableAssessTemplate(num,obj.id,obj.level,obj.levelName,obj.term).then(res => res.data).then(data => {
                            if(data.result) {
                                  this.$message({type: 'success', message: name+'成功!' });
                                  this.getAssessTemplateBySchoolIds();
                           }
                        })
                });
            },
             growthfootprintevaluationtemplateeidt(id) {
                this.$router.push({path: 'growthfootprintevaluationtemplateeidt', query: {id: id}});
            },
        },
    }
</script>

<style lang="scss" scoped>
   .growthBookEvaluationtemplateindex{
       padding: 15px;
       .top{
           padding-bottom: 10px;
               overflow: hidden;
       }
       .link{
           color: #409EFF;
           cursor:pointer;
       }
   }
</style>



// WEBPACK FOOTER //
// src/views/growthfootprint/growthfootprintevaluationtemplateindex.vue